<template>
    <div class="home-page home-page0">
        <Header></Header>
        <div class="home-content mt50">
            <div class="content crfff ac por">
                <!-- 轮播图区域 -->
                <div class="banner-container" ref="bannerContainer">
                    <!-- 轮播图片 -->
                    <div class="banner-wrapper">
                        <div
                            v-for="(banner, index) in bannerList"
                            :key="index"
                            class="banner-item"
                            :class="{ 'active': currentBannerIndex === index }"
                            @click="goToBannerLink(banner)"
                        >
                            <img :src="banner.image" :alt="banner.title || 'banner'" class="banner-image" />
                        </div>
                    </div>
                    <div class="banner-indicator" v-if="bannerList && bannerList.length > 1">
                        <span
                            v-for="(banner, index) in bannerList"
                            :key="index"
                            class="indicator-dot"
                            :class="{ 'active': currentBannerIndex === index }"
                            @click="goToBanner(index)"
                        ></span>
                    </div>
                </div>
              <div ref="tabWrapper" class="tab-wrapper">
                <div class="index-tab disflex" :class="{ 'sticky': isTabSticky }" ref="indexTab">
                  <div
                    class="tab-span"
                    :class="{'active':currentTabIndex==='trending'}"
                    @click="changeTab('trending')"
                  >
                    <img width="16" src="../../static/images/hm-i1.png">
                    <span>{{$t('Trending')}}</span>
                  </div>
                  <div
                    class="tab-span"
                    :class="{'active':currentTabIndex==='face_magic'}"
                    @click="changeTab('face_magic')"
                  >
                    <img width="16" src="../../static/images/hm-i2.png">
                    <span>{{$t('Face_Magic')}}</span>
                  </div>
                  <div
                    class="tab-span"
                    :class="{'active':currentTabIndex==='ai_studio'}"
                    @click="changeTab('ai_studio')"
                  >
                    <img width="16" src="../../static/images/hm-i3.png">
                    <span>{{$t('AI_Studio')}}</span>
                  </div>
                </div>
              </div>

              <div
                v-show="isTabSticky"
                class="tab-placeholder"
                :style="{ height: tabHeight + 'px' }"
              ></div>


                <div class="fs26 mt30" style="margin-bottom: 0.3rem">{{$t('indexTips2')}} :</div>
                <!-- 自定义两列瀑布流：保证按原始顺序左右交替 -->
                <div class="land-content al">
                  <div class="land-col">
                    <div
                      v-for="(item, index) in leftProducts"
                      :key="item.id || 'l-' + index"
                    >
                      <div class="two" @click="goDetail(item.web_path)">
                        <img
                          v-if="item.is_new"
                          style="position: absolute;right: 0px;top: -20px;width: 40%"
                          src="../../static/images/Festival_icon.png"
                        />
                        <div class="cover-wrap">
                          <img :src="item.image" loading="lazy" />
                          <template v-if="item.type === 'video'">
                            <span class="cover-tag cover-tag-left">
                              <img class="cover-tag-icon" src="../../static/images/camera.png" alt="" />
                               {{$t('Shoot_same_video')}}
                            </span>
                            <span v-if="item.video_time" class="cover-tag cover-tag-right">{{ item.video_time }}</span>
                          </template>
                        </div>
                        <div class="fs26 ac">{{ item.title }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="land-col">
                    <div
                      v-for="(item, index) in rightProducts"
                      :key="item.id || 'r-' + index"
                    >
                      <div class="two" @click="goDetail(item.web_path)">
                        <img
                          v-if="item.is_new"
                          style="position: absolute;right: 0px;top: -20px;width: 40%"
                          src="../../static/images/Festival_icon.png"
                        />
                        <div class="cover-wrap">
                          <img :src="item.image" loading="lazy" />
                          <template v-if="item.type === 'video'">
                            <span class="cover-tag cover-tag-left">
                              <img class="cover-tag-icon" src="../../static/images/camera.png" alt="" />
                               {{$t('Shoot_same_video')}}
                            </span>
                            <span v-if="item.video_time" class="cover-tag cover-tag-right">{{ item.video_time }}</span>
                          </template>
                        </div>
                        <div class="fs26 ac">{{ item.title }}</div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
        <div class="footer ac crfff disflex mt100">
          <a href="/" class="home">
            <img style="width: 0.4rem" src="../../static/images/home.png">
            <div class="span crfff">{{$t('Home')}}</div>
          </a>
          <div class="snapbot-ft ac" @click="goDetail('/snapbot')">
            <div class="snapbot-img">
              <img style="width: 1.4rem" src="../../static/images/snapbot-btn.png">
            </div>
            <div class="span crff4fc7">{{$t('snapbot')}}</div>
          </div>
          <a href="/#/myAccount" class="account-ft">
            <img style="width: 0.4rem" src="../../static/images/account-icon.png">
            <div class="span crfff">{{$t('profile')}}</div>
          </a>
        </div>

        <!-- Spin Wheel 弹窗 -->
        <div v-if="showSpinPopup" class="spin-popup">
            <div class="popup-overlay" @click="closeSpinPopup"></div>
            <div class="popup-content">
                <div class="popup-title">{{$t('spin_tip_1')}}</div>
                <div class="popup-subtitle">
                    {{$t('spin_tip_2')}}
                </div>
                <div class="wheel-container" @click="goSpinPage">
                    <img src="../../static/images/spin_wheel.png" alt="wheel" class="wheel-img" />
                </div>
                <button class="letsgo-btn" @click="goSpinPage"></button>
                <div class="close" @click="closeSpinPopup">{{$t('close')}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../components/HeaderOne'
import Dialog from '../components/dialog'

export default {
    components: {
        Header, Dialog
    },
    computed: {
        // 按原始顺序，偶数索引在左列，奇数索引在右列
        leftProducts () {
            if (!Array.isArray(this.product)) return []
            return this.product.filter((_, idx) => idx % 2 === 0)
        },
        rightProducts () {
            if (!Array.isArray(this.product)) return []
            return this.product.filter((_, idx) => idx % 2 === 1)
        }
    },
    data() {
        return {
            info: {},
            isShow: 1,
            isEN: 'bur',
            score: '',
            mobile: '',
            switchFeature: false,
            product: [],
            showSpinPopup: false,
            tabType: 0,
            // 分页相关
            currentPage: 1,
            pageLimit: 10,
            hasMore: true,
            isLoading: false,
            // 轮播相关数据（由 product/banner 接口加载，初始为空避免 undefined）
            bannerList: [],
            currentBannerIndex: 0,
            bannerTimer: null,
            bannerInterval: 3000, // 3秒自动切换
            touchStartX: 0,
            touchEndX: 0,
            currentTabIndex:'trending',
            // 新增的悬停相关数据
            isTabSticky: false,
            tabHeight: 0,
            scrollThreshold: 0,
            lastScrollTop: 0,
            ticking: false,
            scrollDirection: 'down' // 'down' 或 'up'
        }
    },
    mounted() {
        // 启动轮播
        this.startBannerAutoPlay();

        // 添加触摸事件
        this.addTouchEvents();

      // 添加滚动监听
      window.addEventListener('scroll', this.handleScroll, { passive: true });

      // 添加产品列表滚动加载监听
      window.addEventListener('scroll', this.handleProductScroll, { passive: true });

      // 监听窗口大小变化
      window.addEventListener('resize', this.onResize);

      // 初始化计算位置
      this.$nextTick(() => {
        this.calculateTabPosition();
      });
    },
    beforeDestroy() {
        // 清除轮播定时器
        this.stopBannerAutoPlay();
        // 移除触摸事件
        this.removeTouchEvents();
      // 移除事件监听
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('scroll', this.handleProductScroll);
      window.removeEventListener('resize', this.onResize);
    },
    created() {
        this.isEN = localStorage.getItem('lang')
        if (this.$route.query.msisdn) {
            this.mobile = this.$route.query.msisdn
            this.getLogin()
        } else {
            this.getHome()
            this.getBanner()
            this.getProduct(true) // 首次加载重置
        }
    },
    methods: {
        startBannerAutoPlay() {
            if (!this.bannerList || this.bannerList.length <= 1) return;
            this.bannerTimer = setInterval(() => {
                this.nextBanner();
            }, this.bannerInterval);
        },

        // 停止自动轮播
        stopBannerAutoPlay() {
            if (this.bannerTimer) {
                clearInterval(this.bannerTimer);
                this.bannerTimer = null;
            }
        },

        // 切换到下一个轮播
        nextBanner() {
            if (!this.bannerList || this.bannerList.length <= 1) return;
            this.currentBannerIndex = (this.currentBannerIndex + 1) % this.bannerList.length;
        },

        // 切换到上一个轮播
        prevBanner() {
            if (!this.bannerList || this.bannerList.length <= 1) return;

            this.currentBannerIndex = this.currentBannerIndex === 0
                ? this.bannerList.length - 1
                : this.currentBannerIndex - 1;
        },

        // 跳转到指定轮播
        goToBanner(index) {
            if (!this.bannerList || index < 0 || index >= this.bannerList.length) return;
            this.currentBannerIndex = index;
        },

        // 点击轮播图片跳转
        goToBannerLink(banner) {
          console.log(banner.link);
            if (banner.link) {
                this.$router.push(banner.link);
            }
        },

        // 重新开始自动轮播
        restartBannerAutoPlay() {
            this.stopBannerAutoPlay();
            this.startBannerAutoPlay();
        },

        // 添加触摸事件
        addTouchEvents() {
            const container = this.$refs.bannerContainer;
            if (!container) return;

            container.addEventListener('touchstart', this.handleTouchStart);
            container.addEventListener('touchend', this.handleTouchEnd);
        },

        // 移除触摸事件
        removeTouchEvents() {
            const container = this.$refs.bannerContainer;
            if (!container) return;

            container.removeEventListener('touchstart', this.handleTouchStart);
            container.removeEventListener('touchend', this.handleTouchEnd);
        },

        // 触摸开始
        handleTouchStart(e) {
            this.touchStartX = e.changedTouches[0].clientX;
        },

        // 触摸结束
        handleTouchEnd(e) {
            this.touchEndX = e.changedTouches[0].clientX;
            this.handleSwipe();
        },

        // 处理滑动
        handleSwipe() {
            const swipeThreshold = 50;
            const diff = this.touchStartX - this.touchEndX;

            if (Math.abs(diff) > swipeThreshold) {
                if (diff > 0) {
                    this.nextBanner();
                } else {
                    this.prevBanner();
                }
            }
        },
        getContent(type) {
            this.goToBanner(type - 1);
        },

        getLogin() {
            let that = this
            that.$parent.loadModal(true);
            let data = {
                mobile: that.mobile
            }
            that.$api.post('/api/user/fast_login', data, r => {
                that.$parent.loadModal(false);
                if (r.code == 1) {
                    localStorage.setItem('token', r.data.userinfo.token)
                    localStorage.setItem('mobile', r.data.userinfo.mobile)
                    this.getHome();
                    this.getBanner()
                    this.getProduct(true); // 登录后首次加载重置
                } else {
                    that.$utils.alertText(r.msg, 80);
                    this.$router.push({ path: '/land', query: { msisdn: that.mobile } })
                }
            })
        },

        getHome() {
            let that = this;
            that.$api.get('/api/user/info', null, r => {
                that.$parent.returnCode(r, function() {
                    that.score = r.data.score
                });
            })
        },

        getProduct(reset = false) {
            let that = this;

            // 如果重置，清空数据并重置分页
            if (reset) {
                that.product = [];
                that.currentPage = 1;
                that.hasMore = true;
            }

            // 如果正在加载或没有更多数据，则不请求
            if (that.isLoading || !that.hasMore) {
                return;
            }

            that.isLoading = true;
            let data = {
                'group': that.currentTabIndex,
                'page': that.currentPage,
                'limit': that.pageLimit
            };

            that.$api.post('/api/product/list', data, r => {
                that.isLoading = false;
                that.$parent.returnCode(r, function () {
                    if (r.data && r.data.list) {
                        // 追加新数据
                        that.product = that.product.concat(r.data.list);
                        that.hasMore = r.data.hasMore || false;
                        that.currentPage += 1;
                    } else {
                        // 兼容旧接口格式（如果没有分页信息，直接使用返回的数据）
                        if (Array.isArray(r.data)) {
                            that.product = reset ? r.data : that.product.concat(r.data);
                            that.hasMore = r.data.length >= that.pageLimit;
                            that.currentPage += 1;
                        }
                    }
                });
            }, () => {
                that.isLoading = false;
            })
        },
        getBanner() {
          let that = this;
          that.$api.post('/api/product/banner', null, r => {
            that.$parent.returnCode(r, function () {
              // 接口返回的列表在 r.data，保证始终为数组
              that.bannerList = Array.isArray(r.data) ? r.data : [];
              that.currentBannerIndex = 0;
              that.restartBannerAutoPlay();
            });
          }, () => {
            that.bannerList = [];
          });
        },

        goDetail(path) {
            this.$router.push({ path: path });
        },
        goPurchaseChances() {
            this.$router.push({ path: '/purchaseChances' })
        },

        openSpinPopup() {
            this.showSpinPopup = true;
        },

        closeSpinPopup() {
            this.showSpinPopup = false;
        },

        goSpinPage() {
            this.$router.push({ path: '/spin' });
        },
        changeTab(type) {
          this.currentTabIndex = type;
          // 切换 tab 时重置并重新加载
          this.getProduct(true);
        },
      // 计算 tab 位置和高度
      calculateTabPosition() {
        const tabElement = this.$refs.indexTab;
        if (tabElement) {
          this.tabHeight = tabElement.offsetHeight;

          // 计算触发悬停的阈值（tab 距离顶部的距离）
          const rect = tabElement.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          this.scrollThreshold = rect.top + scrollTop - 1.6; // 减去 header 高度
        }
      },

      // 窗口大小变化处理
      onResize() {
        this.calculateTabPosition();
      },
      // 处理滚动
      handleScroll() {
        if (!this.ticking) {
          this.ticking = true;
          requestAnimationFrame(() => {
            this.updateTabSticky();
            this.ticking = false;
          });
        }
      },


      // 更新 tab 悬停状态
      updateTabSticky() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollDirection = scrollTop > this.lastScrollTop ? 'down' : 'up';

        // 更新滚动方向
        this.scrollDirection = scrollDirection;

        // 判断是否需要悬停
        if (scrollTop >= this.scrollThreshold) {
          // 当滚动超过阈值时悬停
          this.isTabSticky = true;
        } else {
          // 当滚动回顶部时恢复
          this.isTabSticky = false;
        }

        // 特殊处理：当向上滚动回到阈值以上时，立即恢复（不要等到完全滚回顶部）
        if (scrollDirection === 'up' && scrollTop < this.scrollThreshold + 10) {
          this.isTabSticky = false;
        }

        this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
      },

      // 处理产品列表滚动加载
      handleProductScroll() {
        if (this.isLoading || !this.hasMore) {
          return;
        }

        // 计算距离底部的距离
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        const documentHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

        // 当滚动到距离底部 200px 时加载下一页
        const threshold = 200;
        if (scrollTop + windowHeight >= documentHeight - threshold) {
          this.getProduct(false);
        }
      },
    }
}
</script>

<style scoped>
/* 轮播图样式 */
.banner-container {
    position: relative;
    width: 100%;
    height:4.5rem;
    overflow: hidden;
    padding-bottom:0.6rem;
}

.banner-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
}

.banner-item {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
    cursor: pointer;
    pointer-events: none;
}

.banner-item.active {
    opacity: 1;
  pointer-events: auto;
}

.banner-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0.4rem;
}

.banner-title {
    position: absolute;
    bottom: 0.2rem;
    left: 0;
    right: 0;
    text-align: center;
    color: white;
    font-size: 0.3rem;
    background: rgba(0, 0, 0, 0.5);
    padding: 0.1rem;
}

/* 轮播指示器 */
.banner-indicator {
    position: absolute;
    bottom: 0.2rem;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    gap: 0.08rem;
    z-index: 2;
}

.indicator-dot {
    width: 0.12rem;
    height: 0.12rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.5);
    cursor: pointer;
    transition: all 0.3s ease;
}

.indicator-dot.active {
    background: white;
    transform: scale(1.2);
}

/* 左右箭头（可选） */
.arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 0.4rem;
    height: 0.4rem;
    background: rgba(0, 0, 0, 0.3);
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 0.3rem;
    z-index: 2;
    user-select: none;
}

.arrow:hover {
    background: rgba(0, 0, 0, 0.5);
}

.left-arrow {
    left: 0.2rem;
}

.right-arrow {
    right: 0.2rem;
}

/* 原有样式保持不变 */
.new-img {
    margin: 0.4rem 0.4rem 0;
    width: auto;
}

.new-img .img-b {
    width: 48%;
    border: 0.04rem solid #0062ff;
    border-radius: 0.1rem;
}

.img-b img {
    width: 100%;
    border-radius: 0.1rem;
}

.snapbot-btn {
    background: url('../../static/images/snapbot-btn.png') no-repeat center center;
    background-size: contain;
    width: 5rem;
    height: 0.9rem;
    border: none;
}

.spin-btn {
    background: url('../../static/images/lucky_spin_btn.png') no-repeat center center;
    background-size: contain;
    width: 5rem;
    height: 0.9rem;
    border: none;
}

.spin-popup {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.popup-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(0.04rem);
}

.popup-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: #fff;
    width: 90%;
}

.popup-title {
    font-size: 0.45rem;
    font-weight: 700;
    margin-bottom: 0.1rem;
}

.popup-subtitle {
    font-size: 0.3rem;
    color: #7fffd4;
    margin: 0.2rem auto 0.2rem;
}

.wheel-container {
    position: relative;
}

.wheel-img {
    width: 100%;
    border-radius: 50%;
}

.letsgo-btn {
    background: url('../../static/images/let_go.png') no-repeat center center;
    background-size: contain;
    padding: 0.7rem 1.8rem;
}

.close {
    color: #fff;
    width: 1rem;
    height: 0.5rem;
    font-size: 0.3rem;
    margin: 0.2rem auto 0;
    border-radius: 0.25rem;
    line-height: 0.5rem;
}

/* 首页产品：自定义两列瀑布流，覆盖全局 column-count 布局 */
.land-content {
    display: flex;
    align-items: flex-start;
    column-count: 1; /* 禁用多列布局，避免“先排满左边再右边” */
    column-gap: 0;
}

.land-col {
    flex: 1;
}

.land-col:first-child {
    margin-right: 0.1rem;
}

.land-col .two {
    width: 100%;
    margin: 0 0 0.1rem 0;
}

.cover-wrap {
    position: relative;
    display: block;
    width: 100%;
    border-radius: 0.18rem;
    overflow: hidden;
}
.cover-wrap > img {
    display: block;
    width: 100%;
    border-radius: 0.18rem;
}
.cover-tag {
    position: absolute;
    bottom: 0.08rem;
    font-size: 0.22rem;
    color: #fff;
    padding: 0.04rem 0.1rem;
    background: rgba(0, 0, 0, 0.45);
    border-radius: 0.04rem;
    display: inline-flex;
    align-items: center;
}
.cover-tag-left .cover-tag-icon {
    width: 0.28rem;
    height: 0.28rem;
    margin-right: 0.06rem;
    flex-shrink: 0;
}
.cover-tag-left {
    left: 0.08rem;
}
.cover-tag-right {
    right: 0.08rem;
}
</style>



// WEBPACK FOOTER //
// src/page/index.vue